import {Directive} from '@angular/core';
import {CellWidgetConfigurableDirective} from '../dashboard/layout/cell/cell-widget-configurable.directive';

@Directive({
    selector: '[page-widget-configurable]',
    standalone: false
})
export class PageWidgetConfigurableDirective extends CellWidgetConfigurableDirective {}
